@if (formFile != null && formFile != undefined) {
  <div [formGroup]="formFile">
    @if (fileText) {
      <span class="body mb-2">
        {{ fileText }}
        @if (required) {
          <span class="text-danger">*</span>
        }
      </span>
    }

    <div class="upload-component p-5 d-column" [ngClass]="backgroundClass">
      @if (loading) {
        <div class="upload-box p-5 d-column c-pointer">
          <div class="loading-file">
            <div class="box-loading py-7 px-5 d-column align-items-center">
              <lib-elux-loading [size]="60" />
              <span class="heading-3 mt-7">Carregando seu arquivo...</span>
            </div>
          </div>
        </div>
      } @else if (formFile.get('url')?.value) {
        <div class="upload-box uploaded p-1 d-column">
          <div class="file-box">
            <div class="file-name px-4 py-1 align-items-center">
              <span class="caption">{{ formFile.get('name')?.value }}</span>
              <span class="caption mx-2">|</span>
              <a (click)="removeFile($event)" class="link-remove">
                <span class="caption me-1">Remover</span>
                <lib-elux-icon [icon]="'Trash.svg'" [size]="'16'" />
              </a>
            </div>
          </div>

          @if (isPdf) {
            <div class="d-flex justify-content-center py-5">
              <div class="pdf-preview">
                <lib-elux-icon [icon]="'PDF_file.svg'" [size]="'100'" />
                <div class="mt-2">{{ formFile.get('name')?.value }}</div>
              </div>
            </div>
          } @else {
            <div class="d-flex justify-content-center py-5">
              <img class="img" [src]="formFile.get('url')?.value" />
            </div>
          }

          <app-system-input-error id="url-error" [field]="formFile.get('url')" />
        </div>

        @if (!isPdf) {
          <span class="body mb-2 pt-5">
            <span>{{ altText }}</span>
            <span class="text-danger">*</span>
            <a
              class="c-pointer ms-2 info-alt"
              [id]="imageUploadTooltipId"
              (mouseenter)="showTooltip = true"
              (mouseleave)="showTooltip = false"
            >
              <lib-elux-icon [icon]="'Info.svg'" size="20" sizeType="px" />
            </a>
          </span>
          <input type="text" formControlName="alt" name="alt" placeholder="Digite um texto alternativo para a imagem" />
          <app-system-input-error id="alt-error" [field]="formFile.get('alt')" />

          <div class="d-row mt-4 align-items-center">
            <input
              type="checkbox"
              id="uploadFileIllustrativeImage"
              formControlName="illustrative"
              (change)="onCheckboxChange($event)"
            />
            <label for="uploadFileIllustrativeImage" class="body ms-2">Imagem ilustrativa</label>
          </div>
        }
      } @else {
        <div
          class="upload-box dragg-box p-5 d-column c-pointer"
          [class.dragging]="isDragging"
          (click)="onClickInput(fileInput)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <lib-elux-icon [icon]="'Upload.svg'" [size]="'35'" />

          <div class="subtitle-1 c-blue py-2">Clique para buscar o arquivo no computador ou arraste-o aqui.</div>
          <div class="body text" [innerHTML]="text"></div>
        </div>
      }
      <input #fileInput type="file" class="hidden-input" (change)="onFileChange($event)" [id]="fileId" />
    </div>
  </div>

  <lib-elux-modal [open]="problemFile.length > 0" (onClose)="problemFile = []">
    <div modal-header>
      <div class="d-row">
        <lib-elux-icon [icon]="'Warning.svg'" size="32" sizeType="px" class="mt-1" />
        <h1 class="heading-1 c-blue ms-3">Não foi possível carregar o arquivo</h1>
      </div>
    </div>
    <div modal-body class="text d-flex flex-column">
      <span class="body mb-2">Confira se o arquivo atende os requisitos abaixo:</span>
      <ul>
        <li [class.bold]="problemFile.includes('type')">Formatos aceitos: {{ formatLabels }}</li>
        @for (f of resolvedFormats; track $index) {
          <li [class.bold]="problemFile.includes('size')">{{ f.label }}: até {{ formatSizeDisplay(f.maxSizeKb) }}</li>
        }
        @if (ratio && !isPdf) {
          <li [class.bold]="problemFile.includes('aspect_ratio')">Proporção da imagem: {{ ratio }}</li>
        }
        @if (width && height && !isPdf) {
          <li [class.bold]="problemFile.includes('width_height')">{{ dimensionLabel }}</li>
        }
      </ul>
    </div>
    <div modal-footer>
      <div class="d-row">
        <lib-elux-button [content]="'Entendido'" [type]="'basic'" (click)="problemFile = []" />
      </div>
    </div>
  </lib-elux-modal>

  @if (showTooltip) {
    <app-tooltip
      (mouseenter)="showTooltip = true"
      (mouseleave)="showTooltip = false"
      (close)="showTooltip = false"
      [elementRelatedName]="imageUploadTooltipId"
      [text]="tooltipAltImage"
    />
  }
}
